import {
  Button,
  Container,
  Flex,
  Heading,
  HStack,
  Image,
  PinInput,
  PinInputField,
  Stack,
  Text,
} from "@chakra-ui/react";
import React, { useEffect, useRef, useState } from "react";
import { images } from "../../utils/utils";
import { useNavigate } from "react-router-dom";
import { CustomButton, InputBox } from "../../utils/LayoutUtils";
import { IoArrowBackOutline } from "react-icons/io5";
import { onLogin } from "../../utils/apis";
import { toast } from "react-toastify";
import store from "../../redux/store";
import {
  get_district_list,
  get_service_list,
  get_user_type,
} from "../../redux/otherSlice";
import { FiEye, FiEyeOff } from "react-icons/fi";
import CustomPopup2 from "../../components/CustomPopup2";

const Login = () => {
  const [isOpen, setIsOpen] = useState(false);
  const otpRef = useRef(null);

  const navigate = useNavigate();
  const [show, setShow] = React.useState(false);
  const [show1, setShow1] = React.useState(false);

  const [data, setData] = useState({ memberID: "" });
  const [loading, setLoading] = useState(false);
  const [showPass, setShowPass] = useState(null);
  const [step, setStep] = useState(1);
  const [memberDetail, setMemberDetail] = useState({});

  useEffect(() => {
    if (data.show_otp) {
      document.querySelector('input[data-index="0"]').focus();
    }
  }, [data.show_otp]);

  const onCheckNumber = () => {
    if (!data.number) {
      setData({
        ...data,
        numMess: !data.number ? "Number is required" : "",
      });
      return;
    }
    const body = new FormData();
    body.append("Mobile_Number", data.number);
    onLogin(body, setLoading)
      .then((res) => {
        console.log("res ===", res);
        if (res.success) {
          if (res.data == 0 || res.data == 1) {
            // setTimeout(() => otpRef.current.focus(), 0);
            setData({
              ...data,
              show_other_reg: false,
              show_otp: true,
              otp_sent_mob: res?.mobile_number,
            });
            setShowPass(res.data);
            toast.success(res.message);
            localStorage.setItem("type", res.data);
          } else if (res.data == 2) {
            navigate("/register", { state: data.number });
          }
        } else {
          toast.error(res.msg);
        }
      })
      .catch((error) => console.log(error));
  };
  const strongPasswordRegex =
    /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{8,}$/;

  const handleLogin = () => {
    if (!data?.memberID && step == 1) {
      setData({
        ...data,
        memberIDMess: !data?.memberID ? "Member ID is required." : "",
      });
      return;
    }
    if ((!data?.emailOTP || data?.emailOTP?.length != 6) && step == 4) {
      setData({
        ...data,
        emailOTPMess: !data?.emailOTP
          ? "OTP is required."
          : data?.emailOTP?.length != 6
          ? "OTP must be six digits."
          : "",
      });
      return;
    }

    if (
      (!data?.name || !data?.number || data?.number?.length != 10) &&
      step == 5
    ) {
      setData({
        ...data,
        nameMess: !data?.name ? "Distributor Name is required." : "",
        numMess: !data?.number
          ? "Distributor Mobile Number is required."
          : data?.number?.length != 10
          ? "Mobile Number must be 10 digits."
          : "",
      });
      return;
    }
    if ((!data?.mobileOTP || data?.mobileOTP?.length != 6) && step == 6) {
      setData({
        ...data,
        mobileOTPMess: !data?.mobileOTP
          ? "OTP is required."
          : data?.mobileOTP?.length != 6
          ? "OTP must be six digits."
          : "",
      });
      return;
    }
    if (
      (!data?.pass ||
        !strongPasswordRegex.test(data.pass) ||
        !data?.cpass ||
        data?.pass != data?.cpass) &&
      step == 7
    ) {
      setData({
        ...data,
        passMess: !data?.pass
          ? "Password is required."
          : !strongPasswordRegex.test(data.pass)
          ? "Password must be at least 8 characters long and include a capital letter, number, and special character."
          : "",
        cpassMess: !data?.cpass
          ? "Confirm Password is required."
          : data?.pass !== data?.cpass
          ? "Password and confirm password do not match."
          : "",
      });
      return;
    }
    if (!data?.pass && step == 9) {
      setData({
        ...data,
        passMess: !data?.pass
          ? "Password is required."
          : // : data?.pass?.length != 6
            // ? "Password must be at least 6 characters long."
            "",
      });
      return;
    }
    const body = new FormData();
    body.append(
      "action",
      step == 1
        ? "member_details"
        : step == 3
        ? "send_email"
        : step == 4
        ? "verify_otp"
        : step == 5
        ? "send_otp"
        : step == 6
        ? "verify_otp"
        : step == 7
        ? "set_password"
        : "member_login"
    );
    body.append("dealer_code", data?.memberID);
    (step == 3 || step == 4) &&
      body.append("email", memberDetail?.DISTRIBUTER_EMAIL);
    step == 4 && body.append("otp", data?.emailOTP);
    step == 5 && body.append("distributer_name", data?.name);
    (step == 6 || step == 5) && body.append("mobile", data?.number);
    step == 6 && body.append("otp", data?.mobileOTP);
    step == 7 && body.append("password", data?.pass);
    step == 7 && body.append("c_password", data?.cpass);
    step == 9 && body.append("password", data?.pass);
    onLogin(body, setLoading)
      .then((res) => {
        console.log("res ===", res);
        if (res.success) {
          toast.success(res.message);
          step == 1 && setMemberDetail(res.data);
          if (step == 7) {
            setIsOpen(true);
            setMemberDetail(res.data);
            localStorage.setItem(
              "member_id",
              JSON.stringify(res?.data?.PROVISIONAL_MEMBERSHIP_NO)
            );
            localStorage.setItem("member_details", JSON.stringify(res?.data));
          }
          if (step == 9) {
            localStorage.setItem(
              "member_id",
              JSON.stringify(res?.data?.PROVISIONAL_MEMBERSHIP_NO)
            );
            localStorage.setItem("member_details", JSON.stringify(res?.data));
            navigate("/");
          }
          if (res?.data?.STATUS == 1 && step == 1) {
            setStep(9);
          } else {
            setStep(step + 1);
          }
          // (step == 8 || step == 7) &&
          //   localStorage.setItem("user", JSON.stringify(res));
          // localStorage.setItem("services", res.service);
          // store.dispatch(get_user_type());
        } else {
          toast.error(res.message);
        }
      })
      .catch((error) => console.log(error));
  };
  const onClickLogin = () => {
    if (
      !data?.number ||
      !data?.pass ||
      (data?.pass && data?.pass?.length != 6)
    ) {
      setData({
        ...data,
        numMess: !data?.number ? "Number is required." : "",
        passMess: !data?.pass
          ? "OTP is required."
          : data?.pass?.length !== 6
          ? "OTP must be six digits."
          : "",
      });
      return;
    }
    const body = new FormData();
    body.append("Mobile_Number", data?.number);
    body.append("otp", data?.pass);
    onLogin(body, setLoading)
      .then((res) => {
        console.log("res ===", res);
        if (res.success) {
          toast.success(res.msg);
          localStorage.setItem("user", JSON.stringify(res));
          localStorage.setItem("mobile", data?.number);
          localStorage.setItem("services", res.service);
          store.dispatch(get_user_type());
          navigate("/profile");
        } else {
          toast.error(res.msg);
        }
      })
      .catch((error) => console.log(error));
  };
  useEffect(() => {
    store.dispatch(get_district_list());
    store.dispatch(get_service_list());
  }, []);

  console.log("step===>", step);

  return (
    <Container
      alignItems={"center"}
      justifyContent={"flex-start"}
      minW="100vw"
      h={"100%"}
      // bg={"brand.white"}
      display={"flex"}
      flexDirection={"column"}
    >
      <Container maxW={"container.lg"} pt={5}>
        <Flex alignSelf={"flex-start"} alignItems={"center"} gap={5}>
          <IoArrowBackOutline
            size={30}
            color="#2b3478"
            cursor={"pointer"}
            onClick={() => navigate(-1)}
          />
          <Text fontSize={[18, 22, 26, 30]} fontWeight={600} color={"#2b3478"}>
            Login
          </Text>
        </Flex>
      </Container>
      {step == 1 && (
        <Stack p={5} maxW="lg" w={"100%"} mt={["10px", 10, 20, 70]}>
          <Image
            src={images.logo}
            h={"150px"}
            w={"150px"}
            objectFit={"contain"}
            alignSelf={"center"}
          />
          <Heading
            fontSize={[16, 18, 20]}
            textAlign={"center"}
            py={2}
            fontWeight={600}
          >
            Enter Member ID
          </Heading>
          <Text fontSize={18} fontWeight={400} color={"brand.black"}>
            Please enter your member ID to proceed
          </Text>
          <InputBox
            label={"Member ID"}
            placeholder={"Member ID"}
            mt={2}
            value={data.memberID}
            // maxLength={10}
            onChange={(v) => {
              setData({
                ...data,
                memberID: v.target.value,
                memberIDMess: "",
              });
            }}
            errorMess={data?.memberIDMess}
          />

          <CustomButton
            title={"Next"}
            mt={5}
            onClick={handleLogin}
            loading={loading}
          />
        </Stack>
      )}
      {step == 2 && (
        <Stack p={5} maxW="lg" w={"100%"} mt={["10px", 10, 20, 70]}>
          <Image
            src={images.logo}
            h={"150px"}
            w={"150px"}
            objectFit={"contain"}
            alignSelf={"center"}
          />
          <Heading
            fontSize={[16, 18, 20]}
            textAlign={"center"}
            py={2}
            fontWeight={600}
          >
            Member Details
          </Heading>
          <Flex
            justifyContent={"space-between"}
            borderBottom={"1px"}
            borderBottomColor={"gray"}
            paddingBlock={"6px"}
          >
            <Text fontSize={16} fontWeight={400} color={"brand.black"}>
              Zone :
            </Text>
            <Text fontSize={16} fontWeight={500} color={"brand.black"}>
              {memberDetail?.ZONE}
            </Text>
          </Flex>
          <Flex
            justifyContent={"space-between"}
            borderBottom={"1px"}
            borderBottomColor={"gray"}
            paddingBlock={"6px"}
          >
            <Text fontSize={16} fontWeight={400} color={"brand.black"}>
              RO Name :
            </Text>
            <Text fontSize={16} fontWeight={500} color={"brand.black"}>
              {memberDetail?.RO_NAME}
            </Text>
          </Flex>
          <Flex
            justifyContent={"space-between"}
            borderBottom={"1px"}
            borderBottomColor={"gray"}
            paddingBlock={"6px"}
          >
            <Text fontSize={16} fontWeight={400} color={"brand.black"}>
              Sales Area :
            </Text>
            <Text fontSize={16} fontWeight={500} color={"brand.black"}>
              {memberDetail?.SALES_AREA}
            </Text>
          </Flex>
          <Flex
            justifyContent={"space-between"}
            borderBottom={"1px"}
            borderBottomColor={"gray"}
            paddingBlock={"6px"}
          >
            <Text fontSize={16} fontWeight={400} color={"brand.black"}>
              Alpha Name :
            </Text>
            <Text fontSize={16} fontWeight={500} color={"brand.black"}>
              {memberDetail?.ALPHA_NAME}
            </Text>
          </Flex>
          <Flex justifyContent={"space-between"}>
            <Text fontSize={16} fontWeight={400} color={"brand.black"}>
              Email :
            </Text>
            <Text fontSize={16} fontWeight={500} color={"brand.black"}>
              {memberDetail?.DISTRIBUTER_EMAIL}
            </Text>
          </Flex>

          <CustomButton
            title={"Verify Email"}
            mt={5}
            onClick={() => setStep(3)}
            loading={loading}
          />
        </Stack>
      )}
      {step == 3 && (
        <Stack p={5} maxW="lg" w={"100%"} mt={["10px", 10, 20, 70]}>
          <Image
            src={images.logo}
            h={"150px"}
            w={"150px"}
            objectFit={"contain"}
            alignSelf={"center"}
          />
          <Heading
            fontSize={[16, 18, 20]}
            textAlign={"center"}
            py={2}
            fontWeight={600}
          >
            Email Verification
          </Heading>
          <Text
            fontSize={18}
            fontWeight={400}
            color={"brand.black"}
            textAlign={"center"}
          >
            We'll send an OTP to your registered email
          </Text>

          <CustomButton
            title={"Send OTP"}
            mt={5}
            onClick={handleLogin}
            loading={loading}
          />
        </Stack>
      )}
      {step == 4 && (
        <Stack p={5} maxW="lg" w={"100%"} mt={["10px", 10, 20, 70]}>
          <Image
            src={images.logo}
            h={"150px"}
            w={"150px"}
            objectFit={"contain"}
            alignSelf={"center"}
          />
          <Heading
            fontSize={[16, 18, 20]}
            textAlign={"center"}
            py={2}
            fontWeight={600}
          >
            Email Verification
          </Heading>

          <Stack display={"flex"} dir="col" justify={"center"} align={"center"}>
            <Text textAlign={"center"} mt={3}>
              We'll send an OTP to your registered email
            </Text>
            <HStack mt={3}>
              <PinInput
                ref={otpRef}
                size="lg"
                placeholder="-"
                onChange={(v) => {
                  setData({ ...data, emailOTP: v, emailOTPMess: "" });
                }}
              >
                <PinInputField
                  border={"1px solid #000"}
                  fontSize="16Spx"
                  w="45px"
                  h="45px"
                />
                <PinInputField
                  border={"1px solid #000"}
                  fontSize="16Spx"
                  w="45px"
                  h="45px"
                />
                <PinInputField
                  border={"1px solid #000"}
                  fontSize="16Spx"
                  w="45px"
                  h="45px"
                />
                <PinInputField
                  border={"1px solid #000"}
                  fontSize="16Spx"
                  w="45px"
                  h="45px"
                />
                <PinInputField
                  border={"1px solid #000"}
                  fontSize="16Spx"
                  w="45px"
                  h="45px"
                />
                <PinInputField
                  border={"1px solid #000"}
                  fontSize="16Spx"
                  w="45px"
                  h="45px"
                />
              </PinInput>
            </HStack>
            {data?.emailOTPMess && (
              <Text color={"#f00"} fontSize={14} mt={1}>
                {data?.emailOTPMess}
              </Text>
            )}
          </Stack>
          <CustomButton
            title={"Login"}
            mt={5}
            onClick={() => handleLogin()}
            loading={loading}
          />
        </Stack>
      )}
      {step == 5 && (
        <Stack p={5} maxW="lg" w={"100%"} mt={["10px", 10, 20, 70]}>
          <Image
            src={images.logo}
            h={"150px"}
            w={"150px"}
            objectFit={"contain"}
            alignSelf={"center"}
          />
          <Heading
            fontSize={[16, 18, 20]}
            textAlign={"center"}
            py={2}
            fontWeight={600}
          >
            Email Verification
          </Heading>
          <Text fontSize={18} fontWeight={400} color={"brand.black"}>
            We'll send an OTP to your registered email
          </Text>

          <InputBox
            placeholder={"Distributor Name"}
            label={"Distributor Name"}
            mt={2}
            value={data.name}
            onChange={(v) => {
              setData({
                ...data,
                name: v.target.value,
                nameMess: "",
              });
            }}
            errorMess={data.nameMess}
          />
          <InputBox
            placeholder={"Distributor Mobile Number"}
            label={"Distributor Mobile Number"}
            mt={2}
            value={data.number}
            maxLength={10}
            onChange={(v) => {
              setData({
                ...data,
                number: v.target.value.trim().replace(/[^0-9 ]/g, ""),
                numMess: "",
              });
            }}
            errorMess={data.numMess}
          />

          <CustomButton
            title={"Login"}
            mt={5}
            onClick={handleLogin}
            loading={loading}
          />
        </Stack>
      )}
      {step == 6 && (
        <Stack p={5} maxW="lg" w={"100%"} mt={["10px", 10, 20, 70]}>
          <Image
            src={images.logo}
            h={"150px"}
            w={"150px"}
            objectFit={"contain"}
            alignSelf={"center"}
          />
          <Heading
            fontSize={[16, 18, 20]}
            textAlign={"center"}
            py={2}
            fontWeight={600}
          >
            Mobile Verification
          </Heading>
          <Text
            fontSize={18}
            fontWeight={400}
            color={"brand.black"}
            textAlign={"center"}
          >
            Enter the 6-digit code sent to your mobile
          </Text>

          <Stack display={"flex"} dir="col" justify={"center"} align={"center"}>
            <Text textAlign={"center"} mt={3}>
              {data?.number}
            </Text>
            <HStack mt={3}>
              <PinInput
                ref={otpRef}
                size="lg"
                placeholder="-"
                onChange={(v) => {
                  setData({ ...data, mobileOTP: v, mobileOTPMess: "" });
                }}
              >
                <PinInputField
                  border={"1px solid #000"}
                  fontSize="16Spx"
                  w="45px"
                  h="45px"
                />
                <PinInputField
                  border={"1px solid #000"}
                  fontSize="16Spx"
                  w="45px"
                  h="45px"
                />
                <PinInputField
                  border={"1px solid #000"}
                  fontSize="16Spx"
                  w="45px"
                  h="45px"
                />
                <PinInputField
                  border={"1px solid #000"}
                  fontSize="16Spx"
                  w="45px"
                  h="45px"
                />
                <PinInputField
                  border={"1px solid #000"}
                  fontSize="16Spx"
                  w="45px"
                  h="45px"
                />
                <PinInputField
                  border={"1px solid #000"}
                  fontSize="16Spx"
                  w="45px"
                  h="45px"
                />
              </PinInput>
            </HStack>
            {data?.mobileOTPMess && (
              <Text color={"#f00"} fontSize={14} mt={1}>
                {data?.mobileOTPMess}
              </Text>
            )}
          </Stack>

          <CustomButton
            title={"Verify"}
            mt={5}
            onClick={handleLogin}
            loading={loading}
          />
        </Stack>
      )}
      {step == 7 && (
        <Stack p={5} maxW="lg" w={"100%"} mt={["10px", 10, 20, 70]}>
          <Image
            src={images.logo}
            h={"150px"}
            w={"150px"}
            objectFit={"contain"}
            alignSelf={"center"}
          />
          <Heading
            fontSize={[16, 18, 20]}
            textAlign={"center"}
            py={2}
            fontWeight={600}
          >
            Mobile Verification
          </Heading>
          <Text
            fontSize={18}
            fontWeight={400}
            color={"brand.black"}
            textAlign={"center"}
          >
            Enter the 6-digit code sent to your mobile
          </Text>

          <InputBox
            label={"Password"}
            placeholder={"Password"}
            value={data.pass}
            onChange={(v) => {
              setData({ ...data, pass: v.target.value.trim(), passMess: "" });
            }}
            errorMess={data.passMess}
            type={show ? "text" : "password"}
            RightElement={
              show ? (
                <FiEyeOff
                  size={20}
                  color="#000"
                  onClick={() => setShow(!show)}
                />
              ) : (
                <FiEye size={20} color="#000" onClick={() => setShow(!show)} />
              )
            }
          />
          <InputBox
            label={"Confirm Password"}
            placeholder={"Confirm Password"}
            value={data.cpass}
            onChange={(v) => {
              setData({ ...data, cpass: v.target.value.trim(), cpassMess: "" });
            }}
            errorMess={data.cpassMess}
            type={show1 ? "text" : "password"}
            RightElement={
              show1 ? (
                <FiEyeOff
                  size={20}
                  color="#000"
                  onClick={() => setShow1(!show1)}
                />
              ) : (
                <FiEye
                  size={20}
                  color="#000"
                  onClick={() => setShow1(!show1)}
                />
              )
            }
          />
          <CustomButton
            title={"Verify"}
            mt={5}
            onClick={handleLogin}
            loading={loading}
          />
        </Stack>
      )}
      {step == 9 && (
        <Stack p={5} maxW="lg" w={"100%"} mt={["10px", 10, 20, 70]}>
          <Image
            src={images.logo}
            h={"150px"}
            w={"150px"}
            objectFit={"contain"}
            alignSelf={"center"}
          />
          <Heading
            fontSize={[16, 18, 20]}
            textAlign={"center"}
            py={2}
            fontWeight={600}
          >
            Login
          </Heading>
          <Text
            fontSize={18}
            fontWeight={400}
            color={"brand.black"}
            textAlign={"center"}
          >
            Enter the 6-digit code sent to your mobile
          </Text>
          <InputBox
            label={"Member ID"}
            placeholder={"Member ID"}
            value={data.memberID}
            disable={true}
          />
          <InputBox
            label={"Password"}
            placeholder={"Password"}
            value={data.pass}
            onChange={(v) => {
              setData({ ...data, pass: v.target.value.trim(), passMess: "" });
            }}
            errorMess={data.passMess}
            type={show ? "text" : "password"}
            RightElement={
              show ? (
                <FiEyeOff
                  size={20}
                  color="#000"
                  onClick={() => setShow(!show)}
                />
              ) : (
                <FiEye size={20} color="#000" onClick={() => setShow(!show)} />
              )
            }
          />

          <CustomButton
            title={"Verify"}
            mt={5}
            onClick={handleLogin}
            loading={loading}
          />
        </Stack>
      )}

      <CustomPopup2 isOpen={isOpen}>
        <Text
          textAlign={"center"}
          fontWeight={600}
          fontSize={"larger"}
          color={"#28a745"}
        >
          🎉 Registration Successful!
        </Text>
        <Text
          textAlign={"center"}
          fontWeight={600}
          fontSize={"medium"}
          color={"#333"}
          marginBlock={2}
        >
          ThankYou For Registered With "AIHPGDA"
        </Text>
        <Stack backgroundColor={"#e8f5e8"} padding={3} alignSelf={"center"}>
          <Text
            textAlign={"center"}
            fontWeight={600}
            fontSize={"large"}
            color={"#28a745"}
          >
            Your Provisional ID:
          </Text>
          <Text
            textAlign={"center"}
            fontWeight={600}
            fontSize={"large"}
            color={"#28a745"}
          >
            {memberDetail?.PROVISIONAL_MEMBERSHIP_NO}
          </Text>
        </Stack>
        <div className="mt-4 text-right">
          <Button
            onClick={() => {
              navigate("/");
              setIsOpen(false);
            }}
            width={"100%"}
            mt={5}
            bg={"#d1262b"}
            _hover={{ bg: "#d1262f" }}
            color={"#ffff"}
          >
            Okay
          </Button>
        </div>
      </CustomPopup2>
    </Container>
  );
};

export default Login;
